import { FIXED_INDENTS, LAYOUT } from 'vars/index'

export const TabControlsType = {
  inRow: 'inRow',
  inRowSecondary: 'inRowSecondary',
} as const
export type TabControlsType =
  (typeof TabControlsType)[keyof typeof TabControlsType]

export const TabsPaddings = {
  None: [FIXED_INDENTS.INDENT_0],
  DEFAULT: [FIXED_INDENTS.INDENT_0, LAYOUT.HorizontalPaddings],
  DEFAULT_70: [FIXED_INDENTS.INDENT_70, LAYOUT.HorizontalPaddings],
  BOTTOM_INDENT_70: [
    FIXED_INDENTS.INDENT_0,
    LAYOUT.HorizontalPaddings,
    FIXED_INDENTS.INDENT_70,
  ],
}
